// app/src/features/timeline/renderers/constants.js
// Lane-band constants shared by the timeline renderers (moved verbatim out of AppInner by PKG-04).
export const STREAM_HALF = 50; // half-height of the forecast stream (YES/NO channels)
// Neutral triggers sit on the spine and alternate sides, so pulling their labels in buys density
// without crowding the line itself.
// The marks are 12px now, so labels sit close to them (was 0.9).
export const NEUTRAL_LABEL_GAP_SCALE = 0.36;
// Scale the GAP, never STREAM_HALF itself: STREAM_HALF also sizes the yes/no stream channel, so
// scaling it would narrow the stream as a side effect. Branch row spacing needs the same factor,
// so laneLayout's FULL_EXTENT / PIE_EXTENT (lib/laneLayout.js) must match.
export const LABEL_GAP_SCALE = 0.9;
// Dashed future-spine thickness (mirrors ForecastLane's SPINE_DASH_PX).
export const SPINE_DASH_PX = 2.67;

// Hairline tethering a trigger's PIE to its TEXT LABEL. Only for on-spine (neutral) triggers: a
// label can sit closer to a NEIGHBOUR's pie than to its own, and nothing said which belonged to
// which.
//
// Held off BOTH ends by TETHER_GAP so it touches neither the circle nor the type — a line
// running into the glyphs reads as an underline or a stem rather than a link. Deliberately the
// faintest thing on the timeline: enough to follow when you look for it and not enough to
// compete with the triggers themselves.
export const TETHER_GAP = 4;
export const TETHER_LINE_H = 11;
